module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "RobotoCondensed-Bold.e1f96d4b.ttf";